import { StatusBadge, theme } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { DashboardUserStatusDetails } from '@/features/dashboard-users/components/DashboardUserStatus/DashboardUserStatusDetails';
import {
  dashboardUserStatus,
  ISupportUser,
  TDashboardUserStatus,
} from '@/features/dashboard-users/store/support-user.model';
import { ToggleTip } from '@/ui-kit/Tips/ToggleTip';
import { useExpirationStatus } from '@/features/dashboard-users/hooks/useexpirationStatus';

interface IDashboardUserStatusProps {
  isBlocked: boolean;
  dashboardUser: ISupportUser;
  rowIndex?: number;
  userId: string;
}

export function DashboardUserStatus({ isBlocked, dashboardUser, rowIndex }: IDashboardUserStatusProps) {
  const { t } = useTranslation();

  const { isExpired, isNearExpiration, accessExpirationDate } = useExpirationStatus(dashboardUser);

  let color: keyof typeof theme.tag = 'green';
  let status: TDashboardUserStatus = dashboardUserStatus.ACTIVE;

  if (isBlocked) {
    color = 'red';
    status = dashboardUserStatus.BLOCKED;
  } else if (isExpired) {
    color = 'gray';
    status = dashboardUserStatus.EXPIRED;
  } else if (isNearExpiration) {
    color = 'darkOrange';
    status = dashboardUserStatus.NEAR_EXPIRED;
  } else if (accessExpirationDate === null) {
    color = 'red';
  }

  return (
    <div className="flex items-center gap-2">
      <StatusBadge
        color={color}
        emphasis="low"
        size="s"
        label={t(`pages.administration.supportsUsers.table.status.value.${status}`)}
      />
      <ToggleTip
        iconVariant="secondary"
        size="s"
        className="z-10"
        icon="info"
        placement={rowIndex !== undefined && rowIndex < 2 ? 'bottom' : 'top'}
      >
        <DashboardUserStatusDetails
          status={status}
          accessExpirationDate={accessExpirationDate}
          userId={dashboardUser.id}
        />
      </ToggleTip>
    </div>
  );
}
